import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/service/auth/auth.service';

@Component({
  selector: 'app-transfer-aba',
  templateUrl: './transfer.component.html',
  styleUrls: ['./transfer.component.css']
})
export class TransferComponent implements OnInit {

  @Output() retornoPost: EventEmitter<any> = new EventEmitter();
  @Input() presenca: any = {};
  @Input() cidadao: any = {};
  @Input() prontuario: any = {};
  @Input() listaAbaTransferencia: any = [];
  @Input() clinicasPorBloco: any = [];

  seeList: boolean = true;
  visualizar_prontuario: any = false;
  constructor(private authService: AuthService) {
    this.authService.visualizarProntuario.subscribe(res => {
      if (res) {
        this.visualizar_prontuario = res;
      }
    });
  }

  ngOnInit() {
  }

  goBack = () => {
    this.seeList = true;
  }

  retornoPostFilho = () => {
    this.retornoPost.emit();
  }

}
